var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16260_111910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8083 4.42275L9.77759 2.42867L9.02583 0.90625H4.96678L4.21481 2.42867L6.18431 4.42275C4.18698 4.80869 2.67188 6.58664 2.67188 8.71823C2.67188 11.1312 4.61192 13.0938 6.9962 13.0938C9.38048 13.0938 11.3205 11.1312 11.3205 8.71823C11.3205 6.58664 9.80542 4.80848 7.8083 4.42275ZM7.27672 3.48086H6.71244L6.4175 2.5867H7.57145L7.27672 3.48086ZM8.78147 1.2995L9.22306 2.19366H8.01061L7.86497 1.2995H8.78147ZM7.98562 2.5867H9.06909L8.1855 3.48086H7.69089L7.98562 2.5867ZM6.52536 1.2995H7.46664L7.61228 2.19366H6.37728L6.52536 1.2995ZM5.21094 1.2995H6.12703L5.97895 2.19366H4.76934L5.21094 1.2995ZM4.9227 2.5867H6.00353L6.29827 3.48086H5.80325L4.9227 2.5867ZM6.9962 12.7005C4.82845 12.7005 3.06492 10.914 3.06492 8.71823C3.06492 6.52245 4.82866 4.73577 6.9962 4.73577C9.16375 4.73577 10.9273 6.52225 10.9273 8.71823C10.9273 10.9142 9.16395 12.7005 6.9962 12.7005Z",
    fill: "#E77B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99963 5.19531C5.07867 5.19531 3.51562 6.77644 3.51562 8.71973C3.51562 10.6632 5.07867 12.2444 6.99963 12.2444C8.92058 12.2444 10.4836 10.6634 10.4836 8.71973C10.4836 6.77644 8.92058 5.19531 6.99963 5.19531ZM6.99963 11.8511C5.2952 11.8511 3.90867 10.4463 3.90867 8.71973C3.90867 6.99317 5.29541 5.58836 6.99963 5.58836C8.70384 5.58836 10.0904 6.99317 10.0904 8.71973C10.0904 10.4463 8.70405 11.8511 6.99963 11.8511Z",
    fill: "#E77B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16260_111910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorRings);
export default __webpack_public_path__ + "static/media/color_rings.07250dd8449e4857b94e1ec5ad515673.svg";
export { ForwardRef as ReactComponent };